import { render, staticRenderFns } from "./PermSelector.vue?vue&type=template&id=a57bc908&scoped=true"
import script from "./PermSelector.vue?vue&type=script&lang=js"
export * from "./PermSelector.vue?vue&type=script&lang=js"
import style0 from "./PermSelector.vue?vue&type=style&index=0&id=a57bc908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57bc908",
  null
  
)

export default component.exports